import React from 'react';

const Dashboard: React.FC = () => <h1>Hi hi!!!</h1>;

export default Dashboard;
